/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EventdetectorDefinitionCheckDirection } from './EventdetectorDefinitionCheckDirection';
import {
    EventdetectorDefinitionCheckDirectionFromJSON,
    EventdetectorDefinitionCheckDirectionFromJSONTyped,
    EventdetectorDefinitionCheckDirectionToJSON,
} from './EventdetectorDefinitionCheckDirection';
import type { EventdetectorDefinitionNotifyInner } from './EventdetectorDefinitionNotifyInner';
import {
    EventdetectorDefinitionNotifyInnerFromJSON,
    EventdetectorDefinitionNotifyInnerFromJSONTyped,
    EventdetectorDefinitionNotifyInnerToJSON,
} from './EventdetectorDefinitionNotifyInner';
import type { EventdetectorDefinitionShiplist } from './EventdetectorDefinitionShiplist';
import {
    EventdetectorDefinitionShiplistFromJSON,
    EventdetectorDefinitionShiplistFromJSONTyped,
    EventdetectorDefinitionShiplistToJSON,
} from './EventdetectorDefinitionShiplist';
import type { GeoJson } from './GeoJson';
import {
    GeoJsonFromJSON,
    GeoJsonFromJSONTyped,
    GeoJsonToJSON,
} from './GeoJson';

/**
 * 
 * @export
 * @interface EventdetectorDefinition
 */
export interface EventdetectorDefinition {
    /**
     * The name of eventdetector
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    name: string;
    /**
     * The id of the eventdetector
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    id?: string | null;
    /**
     * The type of eventdetector: line, polygon, port, cable or fishing. The request must include a valid object of the defined type.
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    type: string;
    /**
     * Access Control list
     * @type {Array<string>}
     * @memberof EventdetectorDefinition
     */
    acl?: Array<string>;
    /**
     * Is the eventdetector enabled
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    enabled: boolean;
    /**
     * Specific activity that should trigger an event
     * @type {object}
     * @memberof EventdetectorDefinition
     */
    activityFilter?: object | null;
    /**
     * Is advanced configuration used
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    advancedConfiguration: boolean;
    /**
     * Use vessel dimensions
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    useVesselDimensions: boolean;
    /**
     * Entire vessel is used
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    entireVessel: boolean;
    /**
     * Send a notification to a ship if it triggers an event
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    sendShipNotification: boolean;
    /**
     * Time it takes until the event triggers
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    timeBeforeActivation?: string;
    /**
     * Time it takes until the event stops triggering
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    timeBeforeDeactivation?: string;
    /**
     * Time it takes until the event stops triggering
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    timeoutWhenActive?: string;
    /**
     * The text to send to the ship
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    shipNotificationText?: string;
    /**
     * The severity of the event
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    severity: string;
    /**
     * The id of the shape to use
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    shape?: string;
    /**
     * 
     * @type {GeoJson}
     * @memberof EventdetectorDefinition
     */
    geometry?: GeoJson;
    /**
     * Id of filter if any
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    filterId?: string | null;
    /**
     * Filter string
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    filterString?: string;
    /**
     * Is an acknowledgment required
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    ackRequired?: boolean;
    /**
     * 
     * @type {EventdetectorDefinitionShiplist}
     * @memberof EventdetectorDefinition
     */
    shiplist?: EventdetectorDefinitionShiplist;
    /**
     * The template used for generating the message sent by mail and/or SMS when an event is activated. The default depends on the type of event definition. You can use various keywords (surrounded by percent signs) that will be replaced before the message is sent. See the aisWeb online help for a list of keywords.
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    activationText?: string;
    /**
     * The template used for generating the message sent by mail and/or SMS when an event is activated. The default depends on the type of event definition. You can use various keywords (surrounded by percent signs) that will be replaced before the message is sent. See the aisWeb online help for a list of keywords.
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    deactivationText?: string;
    /**
     * 
     * @type {EventdetectorDefinitionCheckDirection}
     * @memberof EventdetectorDefinition
     */
    checkDirection?: EventdetectorDefinitionCheckDirection | null;
    /**
     * Time it takes between triggers
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    timeBetweenTriggers?: string;
    /**
     * 
     * @type {Array<EventdetectorDefinitionNotifyInner>}
     * @memberof EventdetectorDefinition
     */
    notify?: Array<EventdetectorDefinitionNotifyInner>;
    /**
     * 
     * @type {string}
     * @memberof EventdetectorDefinition
     */
    owner?: string;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    notifyOnActivation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    notifyOnDeactivation: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    detectNavStatus?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    detectDrifting?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    detectInvalidAis?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    doExitCheck?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    detectSpeedDrop?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    detectAnchoredDrifting?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    detectAnchoredWithin?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    detectAnchoredDriftingOut?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    advancedCableConfig?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    navStatusTriggerThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    driftingSogThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    driftingChdThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    driftingTimeThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    exitCheckThreshold?: number;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    navStatusIgnoreThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    exitCheckTriggerLost?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    deltaSogThreshold?: number;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    circleCenterCpa?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof EventdetectorDefinition
     */
    checkCpa?: boolean;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    cpaLimit?: number;
    /**
     * 
     * @type {number}
     * @memberof EventdetectorDefinition
     */
    tcpaLimit?: number;
}

/**
 * Check if a given object implements the EventdetectorDefinition interface.
 */
export function instanceOfEventdetectorDefinition(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "enabled" in value;
    isInstance = isInstance && "advancedConfiguration" in value;
    isInstance = isInstance && "useVesselDimensions" in value;
    isInstance = isInstance && "entireVessel" in value;
    isInstance = isInstance && "sendShipNotification" in value;
    isInstance = isInstance && "severity" in value;
    isInstance = isInstance && "notifyOnActivation" in value;
    isInstance = isInstance && "notifyOnDeactivation" in value;

    return isInstance;
}

export function EventdetectorDefinitionFromJSON(json: any): EventdetectorDefinition {
    return EventdetectorDefinitionFromJSONTyped(json, false);
}

export function EventdetectorDefinitionFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorDefinition {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'type': json['type'],
        'acl': !exists(json, 'acl') ? undefined : json['acl'],
        'enabled': json['enabled'],
        'activityFilter': !exists(json, 'activity_filter') ? undefined : json['activity_filter'],
        'advancedConfiguration': json['advanced_configuration'],
        'useVesselDimensions': json['use_vessel_dimensions'],
        'entireVessel': json['entire_vessel'],
        'sendShipNotification': json['send_ship_notification'],
        'timeBeforeActivation': !exists(json, 'time_before_activation') ? undefined : json['time_before_activation'],
        'timeBeforeDeactivation': !exists(json, 'time_before_deactivation') ? undefined : json['time_before_deactivation'],
        'timeoutWhenActive': !exists(json, 'timeout_when_active') ? undefined : json['timeout_when_active'],
        'shipNotificationText': !exists(json, 'ship_notification_text') ? undefined : json['ship_notification_text'],
        'severity': json['severity'],
        'shape': !exists(json, 'shape') ? undefined : json['shape'],
        'geometry': !exists(json, 'geometry') ? undefined : GeoJsonFromJSON(json['geometry']),
        'filterId': !exists(json, 'filter_id') ? undefined : json['filter_id'],
        'filterString': !exists(json, 'filter_string') ? undefined : json['filter_string'],
        'ackRequired': !exists(json, 'ack_required') ? undefined : json['ack_required'],
        'shiplist': !exists(json, 'shiplist') ? undefined : EventdetectorDefinitionShiplistFromJSON(json['shiplist']),
        'activationText': !exists(json, 'activation_text') ? undefined : json['activation_text'],
        'deactivationText': !exists(json, 'deactivation_text') ? undefined : json['deactivation_text'],
        'checkDirection': !exists(json, 'check_direction') ? undefined : EventdetectorDefinitionCheckDirectionFromJSON(json['check_direction']),
        'timeBetweenTriggers': !exists(json, 'time_between_triggers') ? undefined : json['time_between_triggers'],
        'notify': !exists(json, 'notify') ? undefined : ((json['notify'] as Array<any>).map(EventdetectorDefinitionNotifyInnerFromJSON)),
        'owner': !exists(json, 'owner') ? undefined : json['owner'],
        'notifyOnActivation': json['notify_on_activation'],
        'notifyOnDeactivation': json['notify_on_deactivation'],
        'detectNavStatus': !exists(json, 'detect_nav_status') ? undefined : json['detect_nav_status'],
        'detectDrifting': !exists(json, 'detect_drifting') ? undefined : json['detect_drifting'],
        'detectInvalidAis': !exists(json, 'detect_invalid_ais') ? undefined : json['detect_invalid_ais'],
        'doExitCheck': !exists(json, 'do_exit_check') ? undefined : json['do_exit_check'],
        'detectSpeedDrop': !exists(json, 'detect_speed_drop') ? undefined : json['detect_speed_drop'],
        'detectAnchoredDrifting': !exists(json, 'detect_anchored_drifting') ? undefined : json['detect_anchored_drifting'],
        'detectAnchoredWithin': !exists(json, 'detect_anchored_within') ? undefined : json['detect_anchored_within'],
        'detectAnchoredDriftingOut': !exists(json, 'detect_anchored_drifting_out') ? undefined : json['detect_anchored_drifting_out'],
        'advancedCableConfig': !exists(json, 'advanced_cable_config') ? undefined : json['advanced_cable_config'],
        'navStatusTriggerThreshold': !exists(json, 'nav_status_trigger_threshold') ? undefined : json['nav_status_trigger_threshold'],
        'driftingSogThreshold': !exists(json, 'drifting_sog_threshold') ? undefined : json['drifting_sog_threshold'],
        'driftingChdThreshold': !exists(json, 'drifting_chd_threshold') ? undefined : json['drifting_chd_threshold'],
        'driftingTimeThreshold': !exists(json, 'drifting_time_threshold') ? undefined : json['drifting_time_threshold'],
        'exitCheckThreshold': !exists(json, 'exit_check_threshold') ? undefined : json['exit_check_threshold'],
        'navStatusIgnoreThreshold': !exists(json, 'nav_status_ignore_threshold') ? undefined : json['nav_status_ignore_threshold'],
        'exitCheckTriggerLost': !exists(json, 'exit_check_trigger_lost') ? undefined : json['exit_check_trigger_lost'],
        'deltaSogThreshold': !exists(json, 'delta_sog_threshold') ? undefined : json['delta_sog_threshold'],
        'circleCenterCpa': !exists(json, 'circle_center_cpa') ? undefined : json['circle_center_cpa'],
        'checkCpa': !exists(json, 'check_cpa') ? undefined : json['check_cpa'],
        'cpaLimit': !exists(json, 'cpa_limit') ? undefined : json['cpa_limit'],
        'tcpaLimit': !exists(json, 'tcpa_limit') ? undefined : json['tcpa_limit'],
    };
}

export function EventdetectorDefinitionToJSON(value?: EventdetectorDefinition | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'id': value.id,
        'type': value.type,
        'acl': value.acl,
        'enabled': value.enabled,
        'activity_filter': value.activityFilter,
        'advanced_configuration': value.advancedConfiguration,
        'use_vessel_dimensions': value.useVesselDimensions,
        'entire_vessel': value.entireVessel,
        'send_ship_notification': value.sendShipNotification,
        'time_before_activation': value.timeBeforeActivation,
        'time_before_deactivation': value.timeBeforeDeactivation,
        'timeout_when_active': value.timeoutWhenActive,
        'ship_notification_text': value.shipNotificationText,
        'severity': value.severity,
        'shape': value.shape,
        'geometry': GeoJsonToJSON(value.geometry),
        'filter_id': value.filterId,
        'filter_string': value.filterString,
        'ack_required': value.ackRequired,
        'shiplist': EventdetectorDefinitionShiplistToJSON(value.shiplist),
        'activation_text': value.activationText,
        'deactivation_text': value.deactivationText,
        'check_direction': EventdetectorDefinitionCheckDirectionToJSON(value.checkDirection),
        'time_between_triggers': value.timeBetweenTriggers,
        'notify': value.notify === undefined ? undefined : ((value.notify as Array<any>).map(EventdetectorDefinitionNotifyInnerToJSON)),
        'owner': value.owner,
        'notify_on_activation': value.notifyOnActivation,
        'notify_on_deactivation': value.notifyOnDeactivation,
        'detect_nav_status': value.detectNavStatus,
        'detect_drifting': value.detectDrifting,
        'detect_invalid_ais': value.detectInvalidAis,
        'do_exit_check': value.doExitCheck,
        'detect_speed_drop': value.detectSpeedDrop,
        'detect_anchored_drifting': value.detectAnchoredDrifting,
        'detect_anchored_within': value.detectAnchoredWithin,
        'detect_anchored_drifting_out': value.detectAnchoredDriftingOut,
        'advanced_cable_config': value.advancedCableConfig,
        'nav_status_trigger_threshold': value.navStatusTriggerThreshold,
        'drifting_sog_threshold': value.driftingSogThreshold,
        'drifting_chd_threshold': value.driftingChdThreshold,
        'drifting_time_threshold': value.driftingTimeThreshold,
        'exit_check_threshold': value.exitCheckThreshold,
        'nav_status_ignore_threshold': value.navStatusIgnoreThreshold,
        'exit_check_trigger_lost': value.exitCheckTriggerLost,
        'delta_sog_threshold': value.deltaSogThreshold,
        'circle_center_cpa': value.circleCenterCpa,
        'check_cpa': value.checkCpa,
        'cpa_limit': value.cpaLimit,
        'tcpa_limit': value.tcpaLimit,
    };
}

